<template>
  <navbar />
  <projects />
  <Footer />
  
</template>

<script>
import Footer from '../components/Footer.vue'
import Navbar from '../components/Navbar.vue'
import Projects from '../components/Projects.vue'
export default {
    name:"Home",
  components: { Navbar, Footer, Projects },

}
</script>

<style>

</style>